import DOMPurify from "isomorphic-dompurify";

// CMS rich-text often arrives with inline `font-family` declarations pasted from
// Word/Office (e.g. `font-family: Aptos, Calibri, ...`). Those override the site
// font (Ping L) and make sections render in the wrong typeface. Strip any inline
// `font-family` so all CMS content inherits the site font, while keeping the rest
// of the inline style (color, font-size, etc.) intact.
//
// Registered as a single global hook here; every component imports DOMPurify from
// this module instead of `isomorphic-dompurify`, so the hook runs in both the
// server (jsdom) and client environments before any `sanitize()` call.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  const el = node as Element;
  if (typeof el.getAttribute !== "function") {
    return;
  }

  const style = el.getAttribute("style");
  if (!style || !/font-family/i.test(style)) {
    return;
  }

  const cleaned = style
    .replace(/font-family\s*:[^;]*;?/gi, "")
    .replace(/;\s*;/g, ";")
    .trim()
    .replace(/^;|;$/g, "")
    .trim();

  if (cleaned) {
    el.setAttribute("style", cleaned);
  } else {
    el.removeAttribute("style");
  }
});

export default DOMPurify;
